module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/55.f05323a6.png";